import React, { useEffect, useState,useRef } from "react";
import { MdOutlineWork, MdOutlineSwapVert } from "react-icons/md";
import { FaFileWaveform } from "react-icons/fa6";
import { HiChartSquareBar } from "react-icons/hi";
import { VscVmRunning } from "react-icons/vsc";
import html2canvas from 'html2canvas';
import { AiOutlineFilePdf } from "react-icons/ai";

import jsPDF from 'jspdf';
import axios from "axios";
import EChartsReact from "echarts-for-react";
import LineChart from 'echarts-for-react';
import './summary.css'
function Summary(){
    const [summaryData,setSummaryData]=useState({})
    const [chartData,setChartData]=useState([])
    const [GraphData,setGraphData]=useState({})
    const pdfRef = useRef();
    function downloadPdf() {
      const input = pdfRef.current;
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfwidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfwidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfwidth - imgWidth * ratio) / 2
        const imgY = 1;
        pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
        pdf.save((new Date()) + ".pdf");
      })
    }

    
    useEffect(()=>{
        signIN()

    },[])
    
      function getDataForChart(val){
        console.log()
        let  data = [
            { value: val["Total rows Processed"],name:`Total rows Processed:`},
            {value:val["Failed rows"],name:`Failed Rows:`}
            
          ];
    return ({
        tooltip: {
          trigger: "item",
          formatter: ``

          
        },
        title: {
          
          text: `${val["DQ Score"]}%`,
          left: 'center',
          top: 'center',
          textStyle:{fontSize:"15px"}
       },
       label:{
formatter:''
       },
       
        series: [
          
          {

            labelLine: {
              
              show:false
            },
            name: "",
            
            type: "pie",
            radius: ["60%","50%"],
            data:data,
            emphasis: {
              itemStyle: {
                
                shadowBlur: 10,
                shadowOffsetX: 0,
                // shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ],
        color:["#3b82f6","silver"]
      })
    }

    function signIN() {
        axios.post(process.env.REACT_APP_API_POINT +"auth/login", { username: "saral", password: "saral" }, { headers: { "Content-Type": "application/x-www-form-urlencoded" } }).then((data) => {
          if (data.data.success == true) {
            sessionStorage.setItem('token', data.data.access_token)
            axios.get(process.env.REACT_APP_API_POINT+'integrify-dashboard/dq-sumamry-Q1', { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((data,err)=>{
                
                if(data.data.success==true){
                  setSummaryData(data.data["DQSummaryData-Q1"][0])
                }
            })
            axios.get(process.env.REACT_APP_API_POINT+"integrify-dashboard/dq-summary-Q2",{ headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((d)=>{
                if(d.data.success){
                    setChartData(d.data["DQSummaryData-Q2"])

                }
            })
            axios.get(process.env.REACT_APP_API_POINT+"integrify-dashboard/dq-summary-Q3",{ headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((d)=>{
                if(d.data.success){
                    let temp={values:[],labels:[]}
                    d.data["DQSummaryData-Q3"].forEach(ele=>{
                         temp.labels.push(ele["Day Flag"])
                         temp.values.push(ele["DQ Score"])
                    })
                    let arr={
                        data: temp.values,
                        type: 'line',
                        color:"#3b82f6",
                        smooth:true,
                        lineStyle:{width:7},
                        symbolSize:10,
                      }
                      temp.values=arr
                    setGraphData(temp)

                }
            })
          }
        })
        }
return (<div ref={pdfRef}>
     <div className='bg-white topics'>
            <div className="row">
                <div className="col-12 grid-margin stretch-card">
                    <div className="card bg-white border0 text-dark">
                        <div className="card-body py-0 px-0 px-sm-3">
                            <div className="row ">
                                <div className="col-12 col-sm-12 col-xl-12 p-0">
                                    <h2 className="mb-1 mb-sm-0 text-dark">DQ WORKFLOW</h2>
                                    <div className="d-flex justify-content-between my-2"><p className="mb-0 font-weight-normal mx-4 my-2 d-none  d-sm-block">Welcome To DatablendIQ</p><button className="btn   text-dark swapButton" onClick={() => downloadPdf()}> <AiOutlineFilePdf className='chart-icon mb-1'></AiOutlineFilePdf>Generate Report</button></div>
                                    {/* section start */}
                                    <div className="row" >
            <div className="col-xl-4 col-sm-6 grid-margin stretch-card "  >
              <div className="card bg-white h-75 text-dark border0  ">
                <div className="card-body interstedBox gradd" >
                  <div className="row">
                    <div className="col-9">
                      <div className="d-flex align-items-center align-self-start">
                        <h5 className="mb-0">OverAll DQ Score</h5>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="icon  ">
                        <MdOutlineWork className="job" />
                      </div>
                    </div>
                  </div>
                  <h3 className="text-muted font-weight-normal">{summaryData['Overall DQ Score']}</h3>

                </div>
              </div>
            </div>
            <div className="col-xl-4 col-sm-6 grid-margin stretch-card">
              <div className="card bg-white h-75 text-dark border0">
                <div className="card-body interstedBox gradd" style={{ backgroundColor: "#ffe08b65" }}>
                  <div className="row">
                    <div className="col-9">
                      <div className="d-flex align-items-center align-self-start">
                        <h5 className="mb-0">Total Rows Processed</h5>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="icon ">
                        <HiChartSquareBar className="chart" />
                      </div>
                    </div>
                  </div>
                  <h3 className="text-muted font-weight-normal">{summaryData["Total rows Processed"]}</h3>

                </div>
              </div>
            </div>
            <div className="col-xl-4 col-sm-6 grid-margin stretch-card">
              <div className="card  bg-white h-75 text-dark border0">
                <div className="card-body interstedBox gradd" style={{ backgroundColor: "#85ff9f5e" }}>
                  <div className="row">
                    <div className="col-9">
                      <div className="d-flex align-items-center align-self-start">
                        <h5 className="mb-0">Failed Rows</h5>

                      </div>
                    </div>
                    <div className="col-3">
                      <div className="icon ">
                        <FaFileWaveform className="form" />
                      </div>
                    </div>
                  </div>
                  <h3 className="text-muted font-weight-normal">{summaryData["Failed rows"]}</h3>

                </div>
              </div>
            </div>
          </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div className="row">
          {chartData.map((ele)=>(<>
            {/* <div className="col-md-2 col-lg-2 col-sm-12"><EChartsReact option={getDataForChart(ele)} /></div> */}
            <div className="col-md-4 col-xl-4 " >
          <div className="card charts ">
            <div className="card-body bg-white text-black " >
              <div className="d-flex flex-row justify-content-between">
                <span className="card-title text-dark graph-label" style={{ marginBottom: "0px" }}>{ele["dataqualitydimension"]}</span>

              </div>
              <EChartsReact option={getDataForChart(ele)} style={{height:"205px"}} />
            </div></div></div>
            </>))}
</div>
 <div className="row">
          
            {/* <div className="col-md-2 col-lg-2 col-sm-12"><EChartsReact option={getDataForChart(ele)} /></div> */}
            <div className="col-md-12 col-xl-12 " >
          <div className="card charts ">
            <div className="card-body bg-white text-black " >
              <div className="d-flex flex-row justify-content-between">
                <span className="card-title text-dark graph-label" style={{ marginBottom: "0px" }}>Overall DQ Score</span>

              </div>
              
              <LineChart height={"20%"} 
        option={{
          legend: {
          
          labels: {
            boxWidth: 12,
            padding: 20,
            fontColor: "#6783b8",
          },
        },
        maintainAspectRatio: false,
          tooltip:{
            show:true
          },
          xAxis: {
            type: 'category',
            data: GraphData.labels,
            boundaryGap:false,
            axisLabel:{
              show:true,
              rotate:60
            }
          },
          yAxis: {
            type: 'value'
          },
          series:GraphData.values
          
        }}
      />
            </div></div></div>
            
</div>


</div>)
}
export default Summary; 